/**
 * What a filial can be declared able to make.
 *
 * Ids are what the rules read (`CAPABILITY_FOR_FORM` in the rules package);
 * labels are what a person sees. A form that is not here needs no equipment,
 * so every branch can make it and nothing constrains it.
 */
export const CAPABILITIES = [
  { id: 'tablets', label: 'Comprimidos' },
  { id: 'sachets', label: 'Envelopes' },
  { id: 'homeopathy', label: 'Homeopatia' },
  { id: 'veterinary', label: 'Veterinário' },
  { id: 'syrups', label: 'Xaropes' },
  { id: 'creams', label: 'Cremes' },
] as const
